import { AV, AV_EMPTY, GH, GW } from './config.js';
import { PALETTE_HEX, paletteIndexOf } from './palette.js';

// Snijdt een geüpload plaatje netjes vierkant en schaalt naar 128×128.
export function squareThumb(file, size) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const c = document.createElement('canvas');
      c.width = size; c.height = size;
      const ctx = c.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      const s = Math.min(img.width, img.height);
      ctx.drawImage(img, (img.width - s) / 2, (img.height - s) / 2, s, s, 0, 0, size, size);
      URL.revokeObjectURL(url);
      c.toBlob((blob) => blob ? resolve({ blob, url: c.toDataURL('image/png') }) : reject(new Error('geen plaatje')), 'image/png');
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('geen plaatje')); };
    img.src = url;
  });
}

let scratchCanvas = null;

export function toPngCanvas(imageData) {
  if (!scratchCanvas) scratchCanvas = document.createElement('canvas');
  scratchCanvas.width = GW; scratchCanvas.height = GH;
  const ctx = scratchCanvas.getContext('2d');
  ctx.clearRect(0, 0, GW, GH);
  ctx.putImageData(imageData, 0, 0);
  const out = document.createElement('canvas');
  out.width = GW; out.height = GH;
  const octx = out.getContext('2d');
  octx.fillStyle = '#fff';
  octx.fillRect(0, 0, GW, GH);
  octx.drawImage(scratchCanvas, 0, 0);
  return out;
}

const PIX_CACHE = new Map();

export function pixUrl(str) {
  if (!str) return '';
  const n = Math.round(Math.sqrt(str.length));
  if (!n || n * n !== str.length) return '';
  if (PIX_CACHE.has(str)) return PIX_CACHE.get(str);
  const c = document.createElement('canvas');
  c.width = n; c.height = n;
  const ctx = c.getContext('2d');
  for (let i = 0; i < str.length; i++) {
    const ch = str[i];
    if (ch === '.') continue;
    const idx = parseInt(ch, 16);
    if (isNaN(idx) || !PALETTE_HEX[idx]) continue;
    ctx.fillStyle = PALETTE_HEX[idx];
    ctx.fillRect(i % n, Math.floor(i / n), 1, 1);
  }
  const url = c.toDataURL('image/png');
  PIX_CACHE.set(str, url);
  return url;
}

// Standaardavatar voor lege/nieuwe accounts: het krabbeltje van Testaccount.
// Wordt bij het laden van de accounts eventueel bijgewerkt naar de serverversie.
export let DEFAULT_AV = '66666666' + '66666666' + '60660666' + '60660666' + '66666666' + '60666606' + '66000066' + '66666666';

export function hasPixels(str) { return !!(str && str.length === AV * AV && /[0-9a-f]/.test(str)); }

export function avatarUrl(str) { return pixUrl(hasPixels(str) ? str : (DEFAULT_AV || AV_EMPTY)); }

export function parseLikedBy(raw) {
  if (!raw) return [];
  let v = raw;
  if (typeof v === 'string') { try { v = JSON.parse(v); } catch (e) { return []; } }
  if (!Array.isArray(v)) return [];
  return v.filter((l) => l && (l.id || l.n)).map((l) => ({ id: l.id || '', n: l.n || '', t: l.t || 0 }));
}

export function encodePixels(data, n) {
  let out = '';
  for (let i = 0; i < n * n; i++) {
    if (data[i * 4 + 3] < 20) { out += '.'; continue; }
    let hex = '#';
    for (let k = 0; k < 3; k++) hex += data[i * 4 + k].toString(16).padStart(2, '0').toUpperCase();
    const idx = paletteIndexOf(hex);
    out += idx >= 0 ? idx.toString(16) : '0';
  }
  return out;
}

/** Het standaardavatar komt van het testaccount, als dat er een heeft. */
export function setDefaultAvatar(pixels) {
  DEFAULT_AV = pixels;
}
